"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowFieldsDisplayGrid = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var globalTypes_1 = require("../../../gen-src/queries/globalTypes");
var NumberCellFormatter_1 = require("../datagrid/cellFormatters/NumberCellFormatter");
var QueryPreservingLinkCellFormatter_1 = require("../datagrid/cellFormatters/QueryPreservingLinkCellFormatter");
var RemoteTypeIcon_1 = require("../datagrid/cellFormatters/RemoteTypeIcon");
var SvgFieldIcon_1 = require("../field/components/SvgFieldIcon");
var FieldNameMapping_1 = require("../field/functions/FieldNameMapping");
var columns = [
    function () { return data_catalog_shared_1.createSelectionColumn(); },
    function (sortParams) { return ({
        name: 'type',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.GridHeaderType(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: data_catalog_shared_1.createIconCellFormatter(function (_a) {
            var fieldIcon = _a.fieldIcon, remoteType = _a.remoteType;
            return remoteType ? React.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: remoteType }) : React.createElement(SvgFieldIcon_1.SvgFieldIcon, { fieldIcon: fieldIcon });
        }, function (_a) {
            var fieldIcon = _a.fieldIcon, remoteType = _a.remoteType;
            return remoteType ? data_catalog_shared_1.RemoteTypeMappings[remoteType]() : fieldIcon ? FieldNameMapping_1.FieldNameMappings[fieldIcon]() : '';
        }),
        sortable: false,
        resizable: false
    }); },
    function (sortParams) { return ({
        name: 'name',
        dataKey: globalTypes_1.FieldOrderField.NAME,
        headerText: Localize_1.Messages.GridHeaderName(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams),
        cellFormatter: QueryPreservingLinkCellFormatter_1.createQueryPreservingReplacingLinkCellFormatter(function (_a) {
            var name = _a.name;
            return name || '';
        }, function (urls, _a) {
            var id = _a.id, flowVizportalUrlId = _a.flowVizportalUrlId;
            return urls.flowLineageFieldPath(flowVizportalUrlId, id);
        }),
        sortable: true,
    }); },
    function (sortParams) { return ({
        name: 'sheets',
        dataKey: data_catalog_shared_1.UnsortableColumnKey,
        headerText: Localize_1.Messages.GridHeaderSheets(),
        headerFormatter: data_catalog_shared_1.createSortableHeaderFormatter(sortParams, 'right'),
        cellFormatter: NumberCellFormatter_1.createNumberCellFormatter(function (_a) {
            var sheetCount = _a.sheetCount;
            return sheetCount;
        }),
        sortable: false,
    }); }
];
function FlowFieldsDisplayGrid(props) {
    var cols = columns.map(function (columnFactory) { return columnFactory(props); });
    return (React.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.FlowFieldsDisplayGrid = FlowFieldsDisplayGrid;
//# sourceMappingURL=FlowFieldsDisplayGrid.js.map